customElements.define(
  'cart-upsell-dynamic',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        addUpsellDynamic: '[data-add-upsell-dynamic]',
        addUpsellDynamicTarget: 'data-add-upsell-dynamic-target',
        addUpsellDynamicProduct: 'data-add-upsell-dynamic-product',
        addUpsellDynamicQuantity: 'data-add-upsell-dynamic-quantity',
        addUpsellDynamicSellingPlan: 'data-add-upsell-dynamic-selling-plan',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );



      this.cartItems = document.querySelector('cart-items');

      console.log("this.addUpsellDynamics");
      console.log(this.addUpsellDynamics);



    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        }
      ];
    }

    async addUpsellDynamic(oldProduct, newProduct, quantity, selling_plan, submitButton) {

      var sections = this.getSectionsToRender().map((section) => section.section);
      var sections_url = window.location.pathname;
      await this.addItem(newProduct, quantity, selling_plan, submitButton);

    }

    async addItem(variantId, quantity, selling_plan, submitButton) {
      const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              selling_plan: selling_plan,
              properties: {
                "_is_upsell": true,
                "_item_selection": "up-sell"
              }
          })
      }).then((response) => {
        return response.text();
      })
      .then(async (state) => {
        
        //
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        this.cartNotifications.forEach((section) => {
          var q = section.getItemsCount();
          section.updateItemsCount(parseInt(q) + parseInt(quantity));
        });

        var dataEvent = {
          "item_name":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_name'),
          "item_id":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_id'),
          "item_barcode":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_barcode'),
          "item_category":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_category'),
          "item_category2":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_category2'),
          "item_variant":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_variant'),
          "pack":"na",
          "product_related1":"na",
          "product_related2":"na",
          "price":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('price')),
          "currency":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('currency'),
          "item_selection": submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_selection'),
          "discount":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('discount')),
        };
  
        var evt = new CustomEvent("gtmAddToCart", {'detail': dataEvent});
        window.dispatchEvent(evt);

        const shopifyCartGTM = await cartManager.getCartGTM();

        console.log(shopifyCartGTM);
        var items = [];
        for (let index = 0; index < shopifyCartGTM.items.length; index++) {
          items.push({
            "index": shopifyCartGTM.items[index].index,
            "item_name": shopifyCartGTM.items[index].title,
            "item_id": shopifyCartGTM.items[index].sku,
            "item_barcode": shopifyCartGTM.items[index].product_id,
            "item_category": shopifyCartGTM.items[index].item_category,
            "item_category2": shopifyCartGTM.items[index].item_category2,
            "item_variant": shopifyCartGTM.items[index].item_variant,
            "pack": shopifyCartGTM.items[index].pack,
            "product_related1": shopifyCartGTM.items[index].product_related1,
            "product_related2": shopifyCartGTM.items[index].product_related2,
            "price": Shopify.formatMoneyNumber(shopifyCartGTM.items[index].original_price),
            "quantity": shopifyCartGTM.items[index].quantity,
            "item_selection":(shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._item_selection != null) ? shopifyCartGTM.items[index].properties._item_selection : "usual",
            "discount": (shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._pack != null) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].total_discount) : (shopifyCartGTM.items[index].discounts != 0) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].discounts) : 0,
          })
        };
  
        var dataEvent_2 = {
          value: Shopify.formatMoneyNumber(shopifyCartGTM.total_price),
          items: items
        };
  
        var evt_2 = new CustomEvent("gtmviewCart", {'detail': dataEvent_2});
        window.dispatchEvent(evt_2);
  
        var dataEvent = {
          "page_type_1": "funnel",
          "page_type_2": "cart",
          "category_1": "na",
          "category_2": "na",
          "environment": datalayer_environment,
          "language": datalayer_language,
          "hashed_256_email": datalayer_hashed_256_email,
          "customer_id": datalayer_customer_id,
          "user_status_login": datalayer_user_status_login,
          "nl_subscriber": datalayer_nl_subscriber
        };
  
        var evt = new CustomEvent("gtmPageviewCart", {'detail': dataEvent});
        window.dispatchEvent(evt);

        this.getSectionsToRender().forEach((section) => {
          if(section.section != null) {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace != null) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            }
          }
        });

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden'),
        );
      });
    }

    async init() {
      console.log('init');      


      this.addUpsellDynamics = document.querySelectorAll(
        this.selectors.addUpsellDynamic,
      );
      
      this.addUpsellDynamics.forEach((addUpsellDynamic) => {
        addUpsellDynamic.addEventListener('click', (event) => {
          this.addUpsellDynamic(
            event.target.dataset.addUpsellDynamicTarget,
            event.target.dataset.addUpsellDynamicProduct,
            event.target.dataset.addUpsellDynamicQuantity,
            (event.target.dataset.addUpsellDynamicSellingPlan != undefined) ? event.target.dataset.addUpsellDynamicSellingPlan: '',
            event.target
          );
        });
      });
    }

    async updateItem(data) {
      const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      }).then((response) => {
        return response.text();
      })
      .then((state) => {

        var button = this.cartItems.querySelector(`[data-key="${data.id}"]`);
        var dataGTM = JSON.parse(button.dataset.productDatalayer);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      });
    }
    
    updateItemById(lineItemId, newQuantity, newProperties = {}) {
        return this.updateItem({
            id: lineItemId,
            quantity: newQuantity,
            properties: newProperties
        });
    }
  

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

  },
);